import { cn } from "@/lib/utils";
import { environmentMarkLabel } from "@/lib/environment";

/** Small "DEV" pill; renders nothing in production (#1099). */
export const EnvironmentBadge = ({ className }: { className?: string }) => {
  const label = environmentMarkLabel();
  if (!label) {
    return null;
  }
  return (
    <span
      title={`${label} test environment`}
      className={cn(
        "inline-flex items-center rounded bg-amber-500 px-1.5 py-0.5 text-xs font-extrabold uppercase tracking-wider text-amber-950",
        className
      )}
    >
      {label}
    </span>
  );
};

/**
 * The DEV mark in the sidebar header, under the logo (#1099): the header row
 * is already full with the logo and the theme toggle. Takes a full row of
 * the header's flex-wrap container.
 */
export const EnvironmentHeaderMark = () => {
  const label = environmentMarkLabel();
  if (!label) {
    return null;
  }
  return (
    <div
      data-testid="environment-header-mark"
      className="flex basis-full items-center gap-2 text-xs font-semibold text-amber-900 dark:text-amber-200"
    >
      <EnvironmentBadge />
      <span>Test environment, not PROD</span>
    </div>
  );
};
